export default __webpack_public_path__ + "static/media/3151.92091db9.png";